export default "__VITE_ASSET__Dp6cveQH__"